<template>
  <!-- 箱子校验table -->
  <div class="cargo-form">
    <el-form ref="ruleForm" status-icon :model="form" :rules="tableRules">
      <el-table
        :data="form.tableData"
        border
        style="width: 100%"
        :cell-style="cellStyle"
        :header-cell-style="{background: 'rgb(242, 246, 252)'}"
      >
        <template v-if="theadData.length>0">
          <el-table-column
            v-if="selectionThead.length>0"
            type="selection"
            :align="selectionThead[0].align?selectionThead[0].align:''"
            :width="selectionThead[0].width?selectionThead[0].width:'55px'"
            :fixed="selectionThead[0].fixed!==undefined?selectionThead[0].fixed:true"
          ></el-table-column>
          <el-table-column
            v-if="indexThead.length>0"
            :align="indexThead[0].align?indexThead[0].align:''"
            :width="indexThead[0].width?indexThead[0].width:'55px'"
            :label="indexThead[0].label?indexThead[0].label:null"
            :prop="indexThead[0].prop"
          ></el-table-column>
          <template v-for="(item,index) in theadFieldsData">
            <el-table-column
              :key="index"
              v-if="(item.showType===undefined||item.showType!==undefined&&item.showType)"
              :label="item.label"
              :align="item.align?item.align:'center'"
              :width="item.width?item.width:'auto'"
              :fixed="item.prop==='operation'?(item.fixed?item.fixed:'right'):false"
              :prop="item.prop"
            >
              <template slot-scope="scope">
                <el-form-item
                  v-if="item.prop!=='operation'"
                  :prop="`tableData.${scope.$index}.${item.prop}`"
                  :rules="getTableRules(scope.$index,item.prop)"
                >
                  <el-input
                    :class="item.align?item.align:'center'"
                    v-if="item.type==='input'&&item.dataType==='Number'"
                    v-model.number="scope.row[item.name]"
                    :readonly="operationType === 'readonly'?true:(scope.row.readonly!==undefined?scope.row.readonly:(item.readonly!==undefined?item.readonly:false))"
                    :disabled="operationType === 'readonly'?true:(scope.row.disabled!==undefined?scope.row.disabled:(item.disabled!==undefined?item.disabled:false))"
                    clearable
                    :placeholder="item.placeholder?item.placeholder:null"
                    @focus="item.focus&&(Object.prototype.toString.call(item.focus)==='[object Function]')?item.focus($event,item,scope.$index,scope.row):null"
                    @change="item.change&&(Object.prototype.toString.call(item.change)==='[object Function]')?item.change($event,item,scope.$index,scope.row):null"
                  ></el-input>
                  <el-input
                    :class="item.align?item.align:'center'"
                    v-if="item.type==='input'&&item.dataType!=='Number'"
                    v-model="scope.row[item.name]"
                    :readonly="operationType === 'readonly'?true:(scope.row.readonly!==undefined?scope.row.readonly:(item.readonly!==undefined?item.readonly:false))"
                    :disabled="operationType === 'readonly'?true:(scope.row.disabled!==undefined?scope.row.disabled:(item.disabled!==undefined?item.disabled:false))"
                    clearable
                    :placeholder="item.placeholder?item.placeholder:null"
                    @focus="item.focus&&(Object.prototype.toString.call(item.focus)==='[object Function]')?item.focus($event,item,scope.$index,scope.row):null"
                    @change="item.change&&(Object.prototype.toString.call(item.change)==='[object Function]')?item.change($event,item,scope.$index,scope.row):null"
                  ></el-input>
                  <el-select
                    style="width:100%"
                    :class="item.align?item.align:'center'"
                    popper-class="form-table-select"
                    v-if="item.type === 'select'"
                    v-model="scope.row[item.name]"
                    :disabled="operationType === 'readonly'?true:(scope.row.disabled!==undefined?scope.row.disabled:(item.disabled!==undefined?item.disabled:false))"
                    :placeholder="item.placeholder?item.placeholder:null"
                    v-loading="item.loading!==undefined?item.loading:false"
                    autocomplete
                    clearable
                    @focus="item.focus&&(Object.prototype.toString.call(item.focus)==='[object Function]')?item.focus($event,item,scope.$index,scope.row):null"
                    @change="item.change&&(Object.prototype.toString.call(item.change)==='[object Function]')?item.change($event,item,scope.$index,scope.row):null"
                  >
                    <template v-if="item.selectType!==undefined&&item.selectType==='item'">
                      <el-option
                        v-for="(item1,index1) in scope.row[item.selectTypeName]"
                        :key="index1"
                        :label="item1.label"
                        :value="item1.value"
                        :disabled="item1.disabled===undefined?false:item1.disabled"
                      ></el-option>
                    </template>
                    <template v-else>
                      <el-option
                        v-for="(item1,index1) in item.selectOptions"
                        :key="index1"
                        :label="item1.label"
                        :value="item1.value"
                        :disabled="item1.disabled===undefined?false:item1.disabled"
                      ></el-option>
                    </template>
                  </el-select>
                  <el-date-picker
                    v-if="item.type === 'daterange'"
                    v-model="scope.row[item.name]"
                    type="daterange"
                    range-separator="-"
                    :start-placeholder="$t('el.datepicker.startDate')"
                    :end-placeholder="$t('el.datepicker.endDate')"
                    :readonly="operationType==='readonly'?true:(scope.row.readonly!==undefined?scope.row.readonly:false)"
                    :disabled="scope.row.disabled?scope.row.disabled:false"
                    :picker-options="item.pickerOptions!==undefined?item.pickerOptions:null"
                  />
                  <el-date-picker
                    v-if="item.type === 'date'"
                    v-model="scope.row[item.name]"
                    type="date"
                    :readonly="operationType==='readonly'?true:(scope.row.readonly!==undefined?scope.row.readonly:false)"
                    :disabled="scope.row.disabled?scope.row.disabled:false"
                    :picker-options="item.pickerOptions!==undefined?item.pickerOptions:null"
                    :placeholder="item.placeholder?item.placeholder:null"
                  ></el-date-picker>
                  <el-date-picker
                    v-if="item.type === 'datetime'"
                    v-model="scope.row[item.name]"
                    type="datetime"
                    :readonly="operationType==='readonly'?true:(scope.row.readonly!==undefined?scope.row.readonly:false)"
                    :placeholder="item.placeholder?item.placeholder:null"
                    :disabled="scope.row.disabled?scope.row.disabled:false"
                    :picker-options="item.pickerOptions!==undefined?item.pickerOptions:null"
                  ></el-date-picker>
                  <el-date-picker
                    v-if="item.type === 'datetimerange'"
                    v-model="ruleForm[item.name]"
                    type="datetimerange"
                    :readonly="operationType==='readonly'?true:(scope.row.readonly!==undefined?scope.row.readonly:false)"
                    :disabled="scope.row.disabled?scope.row.disabled:false"
                    :picker-options="item.pickerOptions!==undefined?item.pickerOptions:null"
                    :placeholder="item.placeholder?item.placeholder:null"
                  ></el-date-picker>
                </el-form-item>
                <div
                  class="flex justify-center align-center operation"
                  v-if="item.prop==='operation'"
                >
                  <el-button
                    v-if="item.options.copy"
                    @click="copy(scope.row)"
                    size="mini"
                    type="primary"
                    icon="el-icon-document-copy"
                    :title="item.textOptions!==undefined&&item.textOptions.copy?item.textOptions.copy:'复制'"
                  >{{item.textOptions!==undefined&&item.textOptions.copy?item.textOptions.copy:'复制'}}</el-button>
                  <el-button
                    v-if="item.options.delete"
                    @click="del(scope.row)"
                    size="mini"
                    style="color:red;"
                    :title="item.textOptions!==undefined&&item.textOptions.delete?item.textOptions.delete:'删除'"
                    icon="el-icon-delete-solid"
                  >{{item.textOptions!==undefined&&item.textOptions.delete?item.textOptions.delete:'删除'}}</el-button>
                </div>
              </template>
            </el-table-column>
          </template>
        </template>
      </el-table>
    </el-form>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    tableIndexMethod: { //
      type: Function
    },
    operationType: {
      type: String,
      default: 'edit'
    },
    dynamicRuleName: { // 动态改变触发校验的字段
      type: String,
      default: ''
    },
    dynamicRuleNameValue: { // 动态改变触发校验的字段对应的值
      type: String,
      default: ''
    },
    dynamicTargetRuleName: { // 动态改变触发校验的目标字段
      type: String,
      default: ''
    },
    tableData: {
      type: Array,
      default: () => {
        return []
      }
    },
    theadData: {
      type: Array,
      default: () => {
        return []
      }
    },
    rules: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      tableRuleOptions: {}
    }
  },
  computed: {
    tableRules () {
      if (this.form.tableData.length > 0) {
        this.theadData.forEach((item) => {
          if (this.rules[item.prop] !== undefined) { // 有prop校验属性时
            this.tableData.forEach((item1, key1) => {
              if (this.rules[item.prop].validator !== undefined && this.rules[item.prop].required) { // 有validator自定义校验方法和必填时
                this.tableRuleOptions[`tableData.${key1}.${item.prop}`] = JSON.parse(JSON.stringify(this.rules[item.prop]))
                this.tableRuleOptions[`tableData.${key1}.${item.prop}`].validator = this.rules[item.prop].validator
              } else {
                this.tableRuleOptions[`tableData.${key1}.${item.prop}`] = JSON.parse(JSON.stringify(this.rules[item.prop]))
              }

              if (this.dynamicRuleName && item1[this.dynamicRuleName] && item1[this.dynamicRuleName] === this.dynamicRuleNameValue) { // 比如dynamicRuleName='chargeUnitCode'时需要校验 dynamicTargetRuleName='basicChargeProjectId'字段
                if (this.tableRuleOptions[`tableData.${key1}.${this.dynamicTargetRuleName}`] !== undefined) {
                  this.$set(this.tableRuleOptions[`tableData.${key1}.${this.dynamicTargetRuleName}`], 'required', true)
                }
              }
            })
          }
        })
      }

      return this.tableRuleOptions
    },
    indexThead () { // 序号列
      return this.theadData.filter((item) => {
        return item.prop === 'index'
      })
    },
    selectionThead () { // 选择列
      return this.theadData.filter((item) => {
        return item.prop === 'selection'
      })
    },
    theadFieldsData () { // 字段列
      const fieldsData = this.theadData.filter((item) => {
        if (this.operationType === 'readonly') {
          return item.prop !== 'selection' && item.prop !== 'index' && item.prop !== 'operation'
        } else {
          return item.prop !== 'selection' && item.prop !== 'index'
        }
      })
      return (this.indexThead.length > 0 || this.selectionThead.length > 0) ? fieldsData : this.theadData
    },
    form: {
      get () {
        return {
          tableData: this.tableData,
          theadData: this.theadFieldsData
        }
      },
      set (data) {
        console.log('data: ', data)
        return data
      }
    }
  },
  watch: {
    'form.tableData': {
      handler (newValue, oldValue) {
        console.log('newValue: ', newValue)
        // this.$emit('boxUpdata', newValue)
      },
      deep: true
    }
  },
  created () {

  },
  methods: {

    setTableItemRules (index, prop, key, value) { // 设置行内对应的校验值
      this.$set(this.tableRuleOptions[`tableData.${index}.${prop}`], key, value)
    },
    getTableRules (index, prop) { // 获取当前的校验选项
      return this.tableRuleOptions[`tableData.${index}.${prop}`]
    },
    copy (item) {
      const data = this.submit()
      if (!data) {
        return
      }
      this.$emit('copy', item)
    },
    del (item) {
      this.$emit('del', item)
    },
    cellStyle ({ row, column, rowIndex, columnIndex }) {
      if (column.property === 'operation') {
        return 'padding:26px 0 30px!important;display:flex;justify-content: center;align-items: flex-start;border-bottom-right-radius:10px'
      } else if (column.type === 'index') {
        return 'padding:27px 0 34px!important;display:flex;justify-content: center;align-items: flex-start;border-bottom-left-radius:10px'
      } else {
        return ''
      }
    },
    submit () {
      let submitData = false
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          const table = JSON.parse(JSON.stringify(this.form.tableData))
          const selectTypeNames = this.theadData.map((item) => {
            return item.selectTypeName
          })
          if (table.length > 0) {
            table.map((item) => {
              Object.keys(item).forEach(key => {
                if (key !== undefined && selectTypeNames.includes(key)) {
                  delete item[key]
                }
                if (key === 'startTime-endTime') {
                  item.startTime = this.$utils.formatDateTime(item[key][0])
                  item.endTime = this.$utils.formatDateTime(item[key][1])
                  delete item[key]
                }
              })
            })
          }
          submitData = table
        }
      })
      if (Object.prototype.toString.call(submitData) === '[object Array]' && submitData.length === 0) {
        submitData = false
      }
      return submitData
    }
  }
}
</script>

<style scoped >
.el-table >>> .el-table__body tr > td {
  padding-top: 14px !important;
  padding-bottom: 0 !important;
}
.cargo-form .el-table,
.cargo-form .el-table__body {
  overflow: hidden;
  border-radius: 10px;
}
.cargo-form .el-table__body tr:last-child,
.cargo-form .el-table__body tr > td:first-child {
  border-bottom-left-radius: 10px;
}
.cargo-form >>> .el-table__body > tbody > tr:last-child,
.cargo-form >>> .el-table__body > tbody > tr > td:last-child {
  border-bottom-right-radius: 10px;
}
.el-table >>> .el-table__header > thead > tr > th,
.cargo-form >>> .el-table__body > tbody > tr > td {
  padding: 6px 0;
}
.el-table >>> .el-table__header > thead > tr,
.el-table >>> .el-table__header > thead > tr > th:first-child {
  border-top-left-radius: 10px;
}
.el-table >>> .el-table__header > thead > tr,
.el-table >>> .el-table__header > thead > tr :last-child {
  border-top-right-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/mainOrders/components/cargo-form.vue